import request from "@/utils/request";

export const saveLoadingInfosFowSeller = (data: any) =>
  request({
    url: "/loading-infos",
    method: "POST",
    data
  });

export const saveLoadingInfosForWarehouse = (data: any) =>
  request({
    url: "/storage-loading-infos",
    method: "POST",
    data
  });

export const deleteLoadingInfosForWarehouse = (id: string) =>
  request({
    url: `/storage-loading-infos/${id}`,
    method: "DELETE"
  });

export const deleteLoadingInfosForSeller = (id: string) =>
  request({
    url: `/loading-infos/${id}`,
    method: "DELETE"
  });





